/**
 * Validation of photos attached to a Willy chat message.
 * Mirrors the backend constraints (vision branch): JPEG/PNG only, max 5MB.
 */
export const WILLY_PHOTO_ALLOWED_TYPES = ['image/jpeg', 'image/png'];
export const WILLY_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const WILLY_PHOTO_MAX_COUNT = 3;

export type WillyPhotoError = 'invalid-type' | 'too-large' | 'too-many';

export function validateWillyPhoto(
  file: Pick<File, 'type' | 'size'>,
): WillyPhotoError | null {
  if (!WILLY_PHOTO_ALLOWED_TYPES.includes(file.type)) {
    return 'invalid-type';
  }
  if (file.size > WILLY_PHOTO_MAX_BYTES) {
    return 'too-large';
  }
  return null;
}
